// src/locales/ky/courses.js
// Kyrgyz course and materials translations (Кыргызча)

export default {
  title: "Веб-иштеп чыгуунун негиздери",

  courses: [
    { id: 'python', name: 'Python' },
    { id: 'javascript', name: 'JavaScript' },
    { id: 'html', name: 'HTML' },
    { id: 'css', name: 'CSS' },
    { id: 'react', name: 'React' }
  ],

  materials: {
    python: [
      {
        id: 1,
        topic: "Өзгөрмөлөр жана маалымат түрлөрү",
        content: "Python-до бир нече негизги маалымат түрлөрү бар: int (бүтүн сандар), float (калкыма чекиттүү сандар), str (саптар), bool (логикалык түр). Өзгөрмөлөр жөнөкөй ыйгаруу менен түзүлөт: x = 10. Python — динамикалык типтеги тил, түрү автоматтык түрдө аныкталат."
      },
      {
        id: 2,
        topic: "Циклдер",
        content: "Python-до циклдин эки негизги түрү бар: for жана while. for цикли ырааттуулуктун элементтерин кайталоо үчүн колдонулат: for i in range(10). while цикли шарт чын болгондо иштейт: while x < 100. Мөөнөтүнөн мурда чыгуу үчүн break, кийинки итерацияга өтүү үчүн continue колдонулат."
      },
      {
        id: 3,
        topic: "Функциялар",
        content: "Python-догу функциялар def ачкыч сөзү менен аныкталат. Синтаксис: def функция_аты(параметрлер): функциянын денеси. Функция return аркылуу маани кайтара алат. Аргументтер позициялык, аталган же демейки маанилерге ээ болушу мүмкүн. Мисал: def sum(a, b=0): return a + b"
      },
      {
        id: 4,
        topic: "Тизмелер",
        content: "Тизме (list) — өзгөртүлүүчү иреттелген элементтердин жыйнагы. Түзүү: my_list = [1, 2, 3] же my_list = list(). Негизги методдор: append() — элемент кошуу, remove() — өчүрүү, sort() — иреттөө, len() — узундукту алуу. Индекстөө 0дөн башталат, кесимдер колдоого алынат: my_list[1:3]"
      }
    ],
    javascript: [
      {
        id: 5,
        topic: "JavaScript'теги өзгөрмөлөр",
        content: "JavaScript'те өзгөрмөлөрдү жарыялоонун үч жолу бар: var (эскирген), let (өзгөрүлүүчү) жана const (константа). Демейки боюнча const колдонуңуз, маанини өзгөртүү керек болгондо let. JavaScript — динамикалык типтеги тил."
      },
      {
        id: 6,
        topic: "Функциялар жана жебе функциялары",
        content: "Функциялар function же жебе синтаксиси (=>) аркылуу жарыяланат. Жебе функциялары кыскараак жана өзүнүн this-и жок. Функциялар — биринчи класстын объекттери, аргументтер катары берилиши мүмкүн."
      },
      {
        id: 7,
        topic: "Массивдер жана методдор",
        content: "JS'деги массивдер — бул объекттер. Негизги методдор: map() (өзгөртүү), filter() (чыпкалоо), reduce() (бириктирүү), forEach() (итерация), find() (издөө). forEach-тен башка бардык методдор жаңы массив кайтарат."
      },
      {
        id: 8,
        topic: "Асинхрондуулук: Promises жана async/await",
        content: "Promise — асинхрондуу операциялар менен иштөө үчүн объект. Абалдары бар: pending, fulfilled, rejected. async/await — промистердин синтаксистик кантты. Async функция ар дайым Promise кайтарат, await аткарууну күтөт."
      }
    ],
    html: [
      {
        id: 9,
        topic: "HTML документинин структурасы",
        content: "HTML документ DOCTYPE, head жана body бар html тегинен турат. Head-де — метамаалыматтар (title, meta, link). Body-де — барактын контенти. Бардык тегдер жабылышы керек (өзү жабылуучулардан башка)."
      },
      {
        id: 10,
        topic: "Семантикалык тегдер",
        content: "Семантикалык тегдер контенттин маанисин сүрөттөйт: header (баш), nav (навигация), main (негизги контент), article (макала), section (бөлүм), aside (каптал панели), footer (төмөнкү). SEO жана жеткиликтүүлүктү жакшыртат."
      },
      {
        id: 11,
        topic: "Формалар жана input элементтери",
        content: "Формалар form теги менен түзүлөт. Негизги input түрлөрү: text, email, password, number, date, checkbox, radio, file. Атрибуттар: name (жөнөтүү үчүн), placeholder (кеңеш), required (милдеттүү), pattern (валидация)."
      }
    ],
    css: [
      {
        id: 12,
        topic: "CSS селекторлору",
        content: "Селекторлор стилдөө үчүн элементтерди тандайт. Түрлөрү: элемент (div), класс (.class), id (#id), атрибут ([type='text']), псевдо-класстар (:hover, :focus), псевдо-элементтер (::before, ::after). Комбинаторлор: тукум (боштук), бала (>), жакын (+)."
      },
      {
        id: 13,
        topic: "Flexbox",
        content: "Flexbox — бир өлчөмдүү жайгаштыруу (сап же тилке). Контейнер: display: flex, flex-direction, justify-content (негизги огу), align-items (кайчылаш огу), gap (аралыктар). Элементтер: flex-grow, flex-shrink, flex-basis."
      },
      {
        id: 14,
        topic: "Grid Layout",
        content: "Grid — эки өлчөмдүү жайгаштыруу (саптар жана тилкелер). Контейнер: display: grid, grid-template-columns/rows (тор аныктоо), gap (аралыктар). Элементтер: grid-column, grid-row (жайгаштыруу), grid-area (аталган аймактар)."
      },
      {
        id: 15,
        topic: "Адаптивдүү дизайн",
        content: "Ар кандай экрандар үчүн медиа сурамдар: @media (max-width: 768px). Mobile-first ыкмасы: алгач мобилдик үчүн стилдер, андан кийин чоң экрандар үчүн. Бирдиктер: rem (root-ко салыштырмалуу), em (ата-энеге салыштырмалуу), vw/vh (viewport), % (ата-энеден пайыз)."
      }
    ],
    react: [
      {
        id: 16,
        topic: "Компоненттер жана JSX",
        content: "Компоненттер — React-тын курулуш блоктору. Функционалдык компоненттер — JSX кайтаруучу кадимки JS функциялары. JSX — HTML-ге окшош синтаксис, бирок бул JavaScript. class ордуна className, атрибуттар үчүн camelCase колдонуңуз."
      },
      {
        id: 17,
        topic: "Хуктар: useState жана useEffect",
        content: "useState — компоненттин абалы үчүн. [маани, өзгөртүү функциясы] кайтарат. useEffect — каптал эффекттери үчүн (сурамдар, жазылуулар). Рендерден кийин иштейт. Көз карандылык массиви кайра иштетүүнү көзөмөлдөйт."
      },
      {
        id: 18,
        topic: "Props жана маалыматтарды берүү",
        content: "Props — компоненттин касиеттери, ата-энеден балага берилет. Өзгөрүлбөс (immutable). Ыңгайлуулук үчүн деструктуризация: ({name, age}). Кыстарылган контент үчүн children prop. Түр валидациясы үчүн PropTypes."
      },
      {
        id: 19,
        topic: "Шарттуу рендеринг жана тизмелер",
        content: "Шарттуу рендеринг: тернардык оператор (condition ? <A/> : <B/>), логикалык оператор (condition && <Component/>). Тизмелер: массивди компоненттерге айландыруу үчүн map(). Оптималдаштыруу үчүн уникалдуу key милдеттүү."
      }
    ]
  },

  faq: [
    {
      id: 1,
      question: "Python кантип орнотуу керек?",
      answer: "python.org сайтынан орноткучту жүктөп алыңыз, аны иштетиңиз жана 'Add Python to PATH' кутучасын белгилеңиз. Орноткондон кийин буйрук сабында текшериңиз: python --version",
      category: "python"
    },
    {
      id: 2,
      question: "Python үчүн кайсы IDE колдонуу керек?",
      answer: "Башталгычтар үчүн PyCharm Community (бекер) же Python кеңейтүүсү бар VS Code сунушталат. Ошондой эле интерактивдүү иштөө жана үйрөнүү үчүн Jupyter Notebook ылайыктуу.",
      category: "python"
    },
    {
      id: 3,
      question: "let менен const-тун айырмасы эмнеде?",
      answer: "const кайра дайындалбай турган өзгөрмөлөр үчүн колдонулат. let — өзгөрүшү мүмкүн болгон өзгөрмөлөр үчүн. const объектти өзгөрүлбөс кылбайт, өзгөрмөнүн өзүн кайра дайындоодон гана сактайт.",
      category: "javascript"
    },
    {
      id: 4,
      question: "CSS'ти HTML-ге кантип туташтыруу керек?",
      answer: "Үч жол: 1) head-де <link rel='stylesheet' href='style.css'> аркылуу тышкы файл. 2) head-де <style> теги аркылуу ички стилдер. 3) Элементтеги style атрибуту аркылуу инлайн стилдер. Тышкы файл сунушталат.",
      category: "css"
    },
    {
      id: 5,
      question: "React тиркемесин кантип түзүү керек?",
      answer: "Буйрукту колдонуңуз: npx create-react-app my-app. Андан кийин cd my-app жана npm start иштетүү үчүн. Же тезирээк курулуш үчүн Vite колдонуңуз: npm create vite@latest my-app -- --template react",
      category: "react"
    },
    {
      id: 6,
      question: "JavaScript'те closure деген эмне?",
      answer: "Closure — тышкы функция аяктагандан кийин да тышкы чөйрөдөн өзгөрмөлөрдү эстеп калган функция. Жеке өзгөрмөлөрдү жана модулдарды түзүү үчүн колдонулат.",
      category: "javascript"
    }
  ],

  initialMessage: "Саламатсызбы! Мен билим берүү платформасынын AI жардамчысымын. **Python**, **JavaScript**, **HTML**, **CSS** жана **React** боюнча суроолорго жардам берем. Каалаган суроону бериңиз!"
};
